import { supabase } from "../lib/supabase";

export async function getOrCreateProdeUser(username: string, email: string) {
  const cleanEmail = email.trim().toLowerCase();
  const cleanUsername = username.trim().toUpperCase();

  const { data: existingUser, error: selectError } = await supabase
    .from("prode_users")
    .select("*")
    .eq("email", cleanEmail)
    .maybeSingle();

  if (selectError) throw selectError;

  if (existingUser) {
    return existingUser;
  }

  const { data, error } = await supabase
    .from("prode_users")
    .insert({
      username: cleanUsername,
      email: cleanEmail,
    })
    .select("*")
    .single();

  if (error) throw error;

  return data;
}



export async function syncProdeMatches() {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

  const response = await fetch(
    `${supabaseUrl}/functions/v1/sync-prode-matches`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${supabaseAnonKey}`,
      },
    }
  );

  const data = await response.json();

  if (!response.ok || !data.ok) {
    throw new Error(data.error ?? "No se pudo sincronizar partidos.");
  }

  return data;
}


export async function getProdeUserByEmail(email: string) {
  const cleanEmail = email.trim().toLowerCase();

  const { data, error } = await supabase
    .from("prode_users")
    .select("*")
    .eq("email", cleanEmail)
    .maybeSingle();

  if (error) throw error;

  return data;
}

export async function getProdeMatches() {
    const { data, error } = await supabase
        .from("prode_matches")
        .select("*")
        .order("date", { ascending: true });

    if (error) {
        throw error;
    }

    return data ?? [];
}

export async function getUserPredictions(userId: string) {
  const { data, error } = await supabase
    .from("prode_predictions")
    .select("*")
    .eq("user_id", userId);

  if (error) throw error;

  return data ?? [];
}

export async function upsertPrediction({
  userId,
  matchId,
  predA,
  predB,
}: {
  userId: string;
  matchId: string;
  predA: number;
  predB: number;
}) {
  const { data, error } = await supabase
    .from("prode_predictions")
    .upsert(
      {
        user_id: userId,
        match_id: matchId,
        pred_a: predA,
        pred_b: predB,
        updated_at: new Date().toISOString(),
      },
      {
        onConflict: "user_id,match_id",
      }
    )
    .select("*")
    .single();

  if (error) throw error;

  return data;
}

export async function getRanking() {
  const { data, error } = await supabase
    .from("prode_ranking")
    .select("*")
    .order("points", { ascending: false });

  if (error) throw error;

  return data ?? [];
}

export async function getProdeUserByUsername(username: string) {
  const cleanUsername = username.trim().toUpperCase();

  const { data, error } = await supabase
    .from("prode_users")
    .select("*")
    .eq("username", cleanUsername)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data;
}